<template>
  <div v-if="siloData.user.id !== 0" id="entry-header" class="eh eh--home bg-color--dark" :data-appstate="appState">
    <div class="eh__content c c--content--pad r r--justify-space-between r--row-always r--halign-center pad--h v--5">
        <div class="eh__content__home-link">

        </div>        
        <div class="eh__content__logo">
            <Icon name="kicknic-logo-new" />
        </div>     
        <div class="eh__content__logout">
            <button onclick="uma.logout();return false;" aria-title="Logout">
                <div class="icon icon--logout"></div>
            </button>
        </div>
    </div>
  </div>
</template>

<script>
import Icon from '@c/Icon.vue';
export default {
    components: {
        Icon,
    },
    data() {
        return {

        }
    },
    props: {
        appState: String,
        siloData: Object,
    },
}
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

$icon_logout: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"><defs><clipPath id="a"><path d="M375,0 L375,667 L0,667 L0,0 L375,0 Z"/></clipPath><clipPath id="b"><path d="M14.0700559,0 C14.3328528,0 14.5889989,0.059850515 14.8295103,0.177361392 C15.060042,0.290024866 15.2667087,0.45090852 15.4428341,0.65434767 C15.617882,0.856523053 15.7553413,1.09209688 15.8510308,1.35340722 C15.9498697,1.62337653 16,1.90965526 16,2.20309353 L16,14.7968906 C16,15.0903095 15.9498762,15.3765841 15.8510462,15.6465624 C15.7553448,15.907891 15.6178913,16.1434503 15.4428457,16.345623 C15.266674,16.5491157 15.059986,16.7100258 14.8294794,16.8226378 C14.5889872,16.9401393 14.3328401,17 14.0700559,17 L12.0209033,17 C11.4516615,17 11,16.4782941 11,15.8469388 C11,15.2155719 11.4516579,14.6938776 12.0209033,14.6938776 L13.9581767,14.6941818 L13.9581767,2.30620455 L12.0209033,2.30612244 C11.4719915,2.30612244 11.0324115,1.82101581 11.0017131,1.22026809 L11,1.15306122 C11,0.521694333 11.4516579,0 12.0209033,0 L14.0700559,0 Z M6.0390323,3.35144226 C6.47157985,3.80801306 6.47157985,4.53989847 6.03903156,4.99639721 L3.83191017,7.32614286 L9.86714383,7.32603909 C10.4751701,7.32603909 10.9639571,7.81905153 10.9980949,8.43145542 L11,8.49997263 C11,9.1437098 10.4976936,9.67390617 9.86714383,9.67390617 L3.83191017,9.67425 L6.03902512,12.0035737 C6.45355559,12.4411035 6.4708277,13.1314795 6.09087299,13.5900465 L6.03906098,13.6485052 C5.82404764,13.8755084 5.53322323,14 5.23058795,14 C4.92794196,14 4.63713127,13.8755116 4.4221441,13.648536 L0.323500794,9.3222744 L0.297537502,9.29377593 L0.260944263,9.25022478 L0.213307951,9.18657359 L0.167408987,9.11538169 C0.138327541,9.06623036 0.113858631,9.0174484 0.09235757,8.96604906 L0.0629965981,8.88804083 L0.0376232081,8.80250989 L0.0206142863,8.72617277 L0.0069954706,8.63522786 L0.000387877982,8.55032982 L0,8.46404725 L0.00391529278,8.39450602 L0.0135267389,8.31524882 L0.0161573361,8.29883993 C0.0220077988,8.26382466 0.0294042772,8.22907742 0.0379233795,8.1960271 L0.0547459122,8.13717925 C0.0717160977,8.08295574 0.0924898191,8.03003195 0.117134527,7.97848981 L0.136726109,7.93935435 L0.177721169,7.86750549 L0.220067933,7.80365524 L0.25868932,7.75252473 L0.323675469,7.67750259 L4.42212208,3.35146498 C4.86602151,2.88283709 5.59510575,2.8828605 6.0390323,3.35144226 Z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(-338 -39)"><g clip-path="url(#b)" transform="matrix(-1 0 0 1 354 39)"><polygon fill="#FFF" points="0 0 16 0 16 17 0 17 0 0"/></g></g></svg>';

.icon {
    &--logout {
        display: block;
        width: rem(16px);
        height: rem(17px);
        background-image: svg-url($icon_logout);
        background-repeat: no-repeat;
    }
}
.eh {   
    overflow: hidden; 
    transition: all 0.15s;
    &--home {
        background-color: var(--color-purple);
    }
}
.eh__content {
    height: var(--height--header-m);
}
.eh__content__logout {
    svg * {
        fill: #fff;
        stroke: #fff;
    }
}
.eh__content__logo {

}
.eh__content__title {
    font-weight: $weight_bold;
}
</style>